import type { AssessmentTest } from '@entities/assessment'

import { questions as questionsMath } from '../questions/math/grade-k1'
import { questions as questionsEla } from '../questions/ela/grade-k1'
import { questionsTest as questionElaTest } from '../questions/ela/grade-k1-test'

export const configK1: AssessmentTest = {
  title: 'Grade 1 math assessment',
  quizTitle: 'Math assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Math check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsMath,
}

export const configK1Ela: AssessmentTest = {
  title: 'Grade 1<br> reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsEla,
}

export const configK1ElaTest: AssessmentTest = {
  title: 'Grade 1<br> reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionElaTest,
}
